<template>
  <div class="toastMask" v-show="visible">
    <div class="no-chance">
      <div class="title"></div>
      <div class="content">
        <img src="../noegg.jpg" v-if="code == 602">
        <img src="../nochance.jpg" v-else>
        <div class="againBtn" @click="close">好的，等你</div>
      </div>
      <div class="close" @click="close"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    code:{
      type: Number,
      default: 601
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.toastMask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
}
.no-chance {
  min-width: 692px;
  width: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  .title {
    line-height: 86px;
    height: 86px;
    background: rgb(49, 78, 113);
    left: 86px;
    color: #fff;
    font-size: 30px;
    text-align: center;
    letter-spacing: 4px;
  }
  .content {
    background: #fff;
    padding: 0 77px;
    margin-bottom: 70px;
    font-size: 22px;
    color: #575757;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 0px;
    }
    .againBtn {
      width: 204px;
      height: 46px;
      background: #334661;
      line-height: 46px;
      text-align: center;
      color: #fff;
      font-size: 26px;
      margin: 0 auto;
      cursor: pointer;
    }
  }
}
.close {
  cursor: pointer;
  position: absolute;
  top: -40px;
  right: -40px;
  width: 39px;
  height: 39px;
  background: url("../close.png") center no-repeat;
  background-size: contain;
}
</style>
